import { Link } from 'react-router-dom';
import "../../Banner/Banner.css";

function Neet_Banner({ path }) {
    const selectedTabStyle = {
        transform: 'scale(1.04)',
        backgroundImage: 'linear-gradient(to top, #bf0023, #8a0347)',
        border: '3px solid #eeffa9',
        boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.26)',
        cursor: 'pointer'
    };

    return (
        <>
            {/* Banner Section Start */}
            <div className='container-fluid Banner-background py-1 pb-0'>
                <div className="container">
                    <div className="d-flex justify-content-center align-items-center flex-column">
                        <div className="row justify-content-center justify-content-md-between w-100">
                            <div className="col-10 col-md-4 mb-1">
                                <Link to='/neet/classes' style={path == '/neet/classes' ? selectedTabStyle : {}} className="text-center card-background list-group-item w-100" >
                                    <div className="bann-card">
                                        <h5 className="banner-title">Classes</h5>
                                        <div style={{ height: "0.1px", backgroundColor: "white", margin: "0" }} />
                                        <p className="banner-paragraph mb-2">NEET</p>
                                    </div>
                                </Link>
                            </div>

                            <div className="col-10 col-md-4 mb-1">
                                <Link to='/neet/study-material' style={path == '/neet/study-material' ? selectedTabStyle : {}} className="text-center card-background list-group-item w-100">
                                    <div className="bann-card">
                                        <h5 className="banner-title">Study Material</h5>
                                        <div style={{ height: "0.1px", backgroundColor: "white", margin: "0" }} />
                                        <p className="banner-paragraph mb-2">NEET</p>
                                    </div>
                                </Link>
                            </div>

                            <div className="col-10 col-md-4 mb-1">
                                <Link to='/neet/testseries' style={path == '/neet/testseries' ? selectedTabStyle : {}} className="text-center card-background list-group-item w-100">
                                    <div className="bann-card">
                                        <h5 className="banner-title">Test Series</h5>
                                        <div style={{ height: "0.1px", backgroundColor: "white", margin: "0" }} />
                                        <p className="banner-paragraph mb-2">NEET</p>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default Neet_Banner;
